import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--float-button"
export default class extends Controller {
  static targets = ["float", "footer", "mv"];

  connect() {
    this.toggle = this.toggle.bind(this);
    window.addEventListener("scroll", this.toggle);
    this.toggle();
  }

  disconnect() {
    window.removeEventListener("scroll", this.toggle);
  }

  toggle() {
    const mvPast = this.mvTarget.getBoundingClientRect().bottom < 0;
    const nearFooter =
      this.footerTarget.getBoundingClientRect().top < window.innerHeight;

    this.floatTarget.classList.toggle("is-visible", mvPast && !nearFooter);
  }
}
